// Copyright (c) 2017 Deere & Company

import SearchByDropDown from '@deere/cps-it.warranty-model-factory/lib/search-by-dropdown';

export const getDefaultState = () =>
    new SearchByDropDown({
        searchBy: [
            {
                key: 'RGA_NUMBER',
                value: 'RGA Number'
            },
            {
                key: 'WARRANTY_CLAIM',
                value: 'Warranty Claim'
            },
            {
                key: 'PART_NUMBER',
                value: 'Part Number'
            },
            {
                key: 'ANALYST',
                value: 'Analyst'
            },
            {
                key: 'MACHINE_PIN',
                value: 'Machine Pin'
            },
            {
                key: 'ENGINE_SN',
                value: 'Engine SN'
            }
        ],
        selectedOption: {
            key: 'RGA_NUMBER',
            value: 'RGA Number'
        }
    });

export default SearchByDropDown;



// WEBPACK FOOTER //
// ./src/rga/search/state/search-by-dropdown.js